import { render, staticRenderFns } from "./ak_setting.vue?vue&type=template&id=7c6aebe8&"
import script from "./ak_setting.vue?vue&type=script&lang=js&"
export * from "./ak_setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports